import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const AdminActivateUser = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [alreadyActivated, setAlreadyActivated] = useState(false);

  const handleActivate = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/auth/admin/activate-user/${token}`);

      setUserInfo({
        email: response.data.user_email,
        name: response.data.user_name
      });
      setAlreadyActivated(response.data.already_activated);
      setSuccess(true);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Failed to activate user. The link may be invalid or expired.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
          <h2>{alreadyActivated ? 'User Already Activated' : 'User Activated Successfully'}</h2>
          <div style={{ color: '#27ae60', marginBottom: '1rem', textAlign: 'center' }}>
            <p>
              <strong>{userInfo?.name || 'User'}</strong><br />
              <span style={{ color: '#666' }}>{userInfo?.email}</span>
            </p>
            <p style={{ marginTop: '1rem' }}>
              {alreadyActivated
                ? 'This user account was already activated previously.'
                : 'The user account has been activated and the user can now log in to Venue IQ.'}
            </p>
          </div>
          <button className="btn" onClick={() => navigate('/login')}>
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
        <h2>Activate User Account</h2>

        {error && (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        {!error && (
          <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.9rem', textAlign: 'center' }}>
            Click the button below to activate this user's account and grant them access to Venue IQ.
          </p>
        )}

        <button
          className="btn"
          onClick={handleActivate}
          disabled={loading}
          style={{ width: '100%' }}
        >
          {loading ? 'Activating...' : 'Activate User Account'}
        </button>

        {!error && (
          <p style={{ marginTop: '1.5rem', color: '#999', fontSize: '0.85rem', textAlign: 'center' }}>
            This is an admin-only function. Only activate users you recognize.
          </p>
        )}
      </div>
    </div>
  );
};

export default AdminActivateUser;
